import SupplierSelect from './src/main';

/* istanbul ignore next */
SupplierSelect.install = function(Vue) {
  Vue.component(SupplierSelect.name, SupplierSelect);
};

export default SupplierSelect;
